import { get } from "src/common/apiClient";
import { getConfig } from "src/apiConfig";
import { handleErrors } from "src/common";
import { IMPERSONATION_ID, SSO } from "src/common/constants";

const url = getConfig(SSO).url;

// Generate a unique session key for storing redirect data
export const generateSessionKey = () => {
  return `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

// Gets an SSO link from the api and then redirects to it
export const ssoRedirect = (item, isImpersonating, params = null) => {
  if (url && item?.id) {
    const queryString = params
      ? `?${new URLSearchParams(params).toString()}`
      : "";

    const finalURL = `${url}/${item.id}${queryString}`;
    return get({
      url: finalURL,
      impersonationHeaders: isImpersonating
        ? {
            impersonationheaderid: sessionStorage.getItem(IMPERSONATION_ID),
            impersonationaction: "SSO Out",
            impersonationdetail: `Name: ${item.name}, Url: ${item.href}`,
          }
        : undefined,
    })
      .then(handleErrors)
      .then((res) => res.json())
      .catch((er) => console.error("Error in SSO Redirect", er));
  } else {
    return Promise.reject(new Error(`Missing id or configured url`));
  }
};

// Store SSO redirect data in sessionStorage and return the session key
export const storeSSORedirecData = (item, isImpersonating, params) => {
  const sessionKey = generateSessionKey();
  const ssoData = {
    item,
    isImpersonating,
    params,
  };
  sessionStorage.setItem(
    `ssoRedirectData_${sessionKey}`,
    JSON.stringify(ssoData),
  );
  return sessionKey;
};

// Retrieve SSO redirect data from sessionStorage
export const getStoredSSORedirecData = (sessionKey) => {
  if (!sessionKey) return null;
  const data = sessionStorage.getItem(`ssoRedirectData_${sessionKey}`);
  if (data) {
    sessionStorage.removeItem(`ssoRedirectData_${sessionKey}`);
    return JSON.parse(data);
  }
  return null;
};

export const handleSSORedirect = (
  item,
  history,
  isImpersonating,
  params = null,
) => {
  if (item.openInNewWindow) {
    // Open SSO URL in a new window
    ssoRedirect(item, isImpersonating, params)
      .then((res) => {
        if (!res) throw new Error("No response");
        window.open(res, "_blank");
      })
      .catch((er) => {
        window.open(
          `/sso-error?label=${encodeURIComponent(item.label)}`,
          "_blank",
        );
      });
  } else {
    // For current window: redirect page with redirect flag, then do SSO API call
    const redirectUrl = `/redirect?label=${encodeURIComponent(item.label)}&redirect=true`;
    history.push(redirectUrl);

    ssoRedirect(item, isImpersonating, params)
      .then((res) => {
        if (!res) throw new Error("No response");
        window.location.href = res;
      })
      .catch((er) => {
        history.push(`/sso-error?label=${encodeURIComponent(item.label)}`);
      });
  }
};
